import { MODE_OF_TRANSPORT_RAIL, MODE_OF_TRANSPORT_ROAD } from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0543Validator = {
  validateConsignmentConsignorRequirement: ({
    security,
    specificCircumstanceIndicator,
    reducedDatasetIndicator,
  }: {
    security: string
    specificCircumstanceIndicator?:string
    reducedDatasetIndicator?:string
  }): RuleResult => {
    if (['1', '3'].includes(security)) {
      return specificCircumstanceIndicator && [MODE_OF_TRANSPORT_ROAD, MODE_OF_TRANSPORT_RAIL].includes(specificCircumstanceIndicator)
        ? 'REQUIRED'
        : 'NOT_ALLOWED'
    }

    return security === '0' && reducedDatasetIndicator === 'true' ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0543Validator
